import { Languages } from "lucide-react";
import { useI18n } from "../lib/i18n.js";

export function LocaleToggle() {
  const { locale, setLocale, t } = useI18n();
  const next = locale === "zh-CN" ? "en-US" : "zh-CN";

  return (
    <button className="icon-text-button ghost" type="button" onClick={() => setLocale(next)} aria-label={t("language")}>
      <Languages size={18} />
      <span>{locale === "zh-CN" ? "EN" : "中文"}</span>
    </button>
  );
}
